import { Reducer } from 'redux'
import {
    AssumedInjuryV2,
    ClearReportTypes,
    CreateReportTypes,
    GetReportTypes,
    InjuryDataV2Types,
    Report,
    ReportState
} from './types'

const INITIAL_STATE: ReportState = {
  data: {} as Report,
  loading: false,
  error: false,
  errorStack: undefined
}

const reducer: Reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CreateReportTypes.CREATE_REPORT_REQUEST:
    case GetReportTypes.GET_REPORT_REQUEST:
      return { ...state, loading: true, error: false, errorStack: undefined }
    case CreateReportTypes.CREATE_REPORT_SUCCESS:
    case GetReportTypes.GET_REPORT_SUCCESS:
      return {
        ...state,
        data: { ...state.data, ...action.payload },
        loading: false,
        error: false,
        errorStack: undefined
      }
    case CreateReportTypes.CREATE_REPORT_FAILURE:
    case GetReportTypes.GET_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorStack: action.payload.errorStack
      }
    case ClearReportTypes.CLEAR_REPORT_SUCCESS:
      return {
        data: {},
        loading: false,
        error: false,
        errorStack: null
      }
    case GetReportTypes.GET_REPORT_REQUEST_OVERRIDE:
      return { ...state, loading: true, error: false, errorStack: undefined }
    case GetReportTypes.GET_REPORT_SUCCESS_OVERRIDE:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        errorStack: undefined
      }
    case GetReportTypes.GET_REPORT_FAILURE_OVERRIDE:
      return {
        ...state,
        loading: false,
        error: true,
        errorStack: action.payload.errorStack
      }
    case ClearReportTypes.CLEAR_REPORT_HEATMAP_LOCATION:
      return {
        ...state,
        data: {
          ...state.data,
          heatmap: undefined
        }
      }

    // InjuryDataV2 Actions
    case InjuryDataV2Types.SET_INJURY_DATA_V2:
      return {
        ...state,
        data: {
          ...state.data,
          injuryDataV2: action.payload
        }
      }

    case InjuryDataV2Types.ADD_ASSUMED_INJURY_V2:
      return {
        ...state,
        data: {
          ...state.data,
          injuryDataV2: {
            ...state.data.injuryDataV2,
            assumedInjuries: [
              ...(state.data.injuryDataV2?.assumedInjuries || []),
              action.payload
            ]
          }
        }
      }

    case InjuryDataV2Types.UPDATE_ASSUMED_INJURY_V2:
      return {
        ...state,
        data: {
          ...state.data,
          injuryDataV2: {
            ...state.data.injuryDataV2,
            assumedInjuries:
              state.data.injuryDataV2?.assumedInjuries?.map(
                (injury: AssumedInjuryV2, index: number) =>
                  index === action.payload.index
                    ? { ...injury, ...action.payload.injury }
                    : injury
              ) || []
          }
        }
      }

    case InjuryDataV2Types.REMOVE_ASSUMED_INJURY_V2:
      return {
        ...state,
        data: {
          ...state.data,
          injuryDataV2: {
            ...state.data.injuryDataV2,
            assumedInjuries:
              state.data.injuryDataV2?.assumedInjuries?.filter(
                (_: AssumedInjuryV2, index: number) => index !== action.payload
              ) || []
          }
        }
      }

    default:
      return state
  }
}

export default reducer
